import { useToken } from '@/app/hooks';
import { useMyProfile } from '@/app/hooks/user/myprofile';
import { USER_LOG_TYPE, useUserLogger } from '@/app/hooks/userLogger';
import { useEffect } from 'react';
import { useIsMobile } from './CalVW';
import { API_URL } from '@/app/constants/APIKEYS';
import { activityLogger, Actions } from './activityLogger';

const UnloadLog = () => {
  const { token } = useToken();
  const { userIp } = useUserLogger();
  const { data: user } = useMyProfile();
  const isMobile = useIsMobile();

  useEffect(() => {
    // ✅ token, user, userIp 모두 준비될 때까지 대기
    if (!token || !user?.id || !userIp?.ip) return;

    const handleBeforeUnload = async () => {
      try {
        // ✅ 실행 시점에 다시 한번 token 체크
        if (!token) return;

        // ⚠️ PAGE_LEAVE 로깅 제거
        // activityLogger가 내부적으로 beforeunload/visibilitychange에서 flush() 호출하므로
        // 여기서 별도로 PAGE_LEAVE를 로깅하면 중복됨
        // 버퍼에 쌓인 로그만 전송 (activityLogger가 이미 처리)

        const headers: Record<string, string> = {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
        };

        const body = {
          userid: user.id,
          log: USER_LOG_TYPE.UNLOAD,
          data: USER_LOG_TYPE.UNLOAD,
          platform: isMobile ? 'M' : 'W',
          ip: userIp.ip,
        };

        await fetch(API_URL + '/system/log', {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
          keepalive: true,
        });
      } catch (error) {
        // ✅ 로깅 실패는 무시 (로그아웃 트리거 안함)
        console.log('UnloadLog error (ignored):', error);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [token, user?.id, isMobile, userIp?.ip]);

  return null;
};

export default UnloadLog;
